import Title from 'antd/es/typography/Title';
import styled from 'styled-components';

export const StyledTitle = styled(Title)`
  &.ant-typography {
    font-weight: 400;
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;
